<template>
  <section class="form-section">
    <h1 class="form-section__title">
      {{ $t('FINANCE.SETTLEMENT_MISC.TITLE') }}
    </h1>

    <div class="row align-justify">
      <div class="small-12 columns">
        <div class="table-responsive raised">
          <table class="table table--padded table--hover">
            <thead>
              <tr>
                <th>{{ $t('FINANCE.SETTLEMENT_MISC.AMOUNT') }}</th>
                <th>{{ $t('FINANCE.SETTLEMENT_MISC.DATE') }}</th>
                <th>{{ $t('FINANCE.SETTLEMENT_MISC.DESC') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in miscTransactions" :key="index">
                <td>{{ currencyFormat(row.amount) }} {{ $t('RIALS') }}</td>
                <td v-if="row.date">
                  {{ translateDate(row.date) }}
                </td>
                <td v-else>
                  —
                </td>
                <td>{{ row.message_fa }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SETTLEMENT_MISC_TRANSACTIONS } from '@/store/types';

import { dateFormat } from '@/utils/date';
import { format as currencyFormat } from '@/utils/number';
import lang from '@/mixins/lang';

export default {
  name: 'SettlementMisc',
  mixins: [lang],
  computed: {
    miscTransactions() {
      return this.$store.getters[SETTLEMENT_MISC_TRANSACTIONS];
    },
  },

  methods: {
    currencyFormat,

    translateDate(date) {
      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      return dateFormat()(toFormat)(date);
    },
  },
};
</script>
